(function() {
  'use strict';

  function initCarousel(wrapper) {
    const carousel = wrapper.querySelector('.reviews-carousel');
    const track = carousel.querySelector('.reviews-carousel-track');
    const items = Array.from(track.querySelectorAll('.reviews-carousel-item'));
    const prevBtn = carousel.querySelector('.reviews-carousel-arrow--prev');
    const nextBtn = carousel.querySelector('.reviews-carousel-arrow--next');
    
    if (items.length === 0) return;

    let currentIndex = 0;
    let columns = parseInt(carousel.dataset.columns) || 3;

    function getColumns() {
      return window.innerWidth < 768 ? 1 : columns;
    }

    function updateCarousel(animate = true) {
      const currentColumns = getColumns();
      const firstItem = items[0];
      const itemWidth = firstItem.offsetWidth;
      const gap = 20; // Match the gap in CSS
      const offset = -(currentIndex * (itemWidth + gap));
      
      track.style.transition = animate ? 'transform 0.4s ease' : 'none';
      track.style.transform = `translateX(${offset}px)`;

      // Update button states
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= items.length - currentColumns;
    }

    function goToNext() {
      const currentColumns = getColumns();
      if (currentIndex < items.length - currentColumns) {
        currentIndex++;
        updateCarousel();
      }
    }

    function goToPrev() {
      if (currentIndex > 0) {
        currentIndex--;
        updateCarousel();
      }
    }

    // Event listeners
    nextBtn.addEventListener('click', goToNext);
    prevBtn.addEventListener('click', goToPrev);

    // Touch/swipe support
    let touchStartX = 0;
    let touchEndX = 0;

    track.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    track.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    }, { passive: true });

    function handleSwipe() {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;

      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          goToNext();
        } else {
          goToPrev();
        }
      }
    }

    // Resize handler with debounce
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        const currentColumns = getColumns();
        // Reset to first slide if current position is invalid after resize
        if (currentIndex >= items.length - currentColumns) {
          currentIndex = Math.max(0, items.length - currentColumns);
        }
        updateCarousel(false);
      }, 150);
    });

    // Wait for images to load before initializing
    const images = wrapper.querySelectorAll('img');
    if (images.length > 0) {
      let loadedImages = 0;
      const totalImages = images.length;

      function onImageLoad() {
        loadedImages++;
        if (loadedImages === totalImages) {
          updateCarousel(false);
        }
      }

      images.forEach(function(img) {
        if (img.complete) {
          onImageLoad();
        } else {
          img.addEventListener('load', onImageLoad);
          img.addEventListener('error', onImageLoad); // Handle errors too
        }
      });
    } else {
      // No images, initialize immediately
      updateCarousel(false);
    }
  }

  // Initialize all carousels on the page
  function initAllCarousels() {
    const carouselWrappers = document.querySelectorAll('.reviews-carousel-wrapper');
    carouselWrappers.forEach(initCarousel);
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCarousels);
  } else {
    initAllCarousels();
  }

  // Shopify theme editor support
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      const wrapper = event.target.querySelector('.reviews-carousel-wrapper');
      if (wrapper) {
        setTimeout(function() {
          initCarousel(wrapper);
        }, 100);
      }
    });
  }
})();